import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { ErrorConfig } from 'graphql/types'
import { useTranslation } from 'react-i18next'

export interface ErrorDialogProps {
    errorConfig?: ErrorConfig
    onClick: () => void
}

const ErrorDialog = (props: ErrorDialogProps): JSX.Element => {
    const ec = props.errorConfig
    const { t } = useTranslation()

    return (
        <>
            {ec && (
                <Dialog disableEscapeKeyDown={false} aria-labelledby="customized-dialog-title" open={true}>
                    <DialogTitle id="customized-dialog-title">{ec.title}</DialogTitle>
                    <DialogContent style={{ padding: '24px' }} dividers>
                        <Typography>{ec.content}</Typography>
                        {ec.messages && <Typography>{ec.messages}</Typography>}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={props.onClick}>{t('components.errorDialog.ok')}</Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    )
}

export default ErrorDialog
